// Chakra imports
import { ChakraProvider, Portal, useDisclosure } from '@chakra-ui/react';
import Configurator from 'components/Configurator/Configurator';
import Footer from 'components/Footer/Footer.js';
// Layout components
import AdminNavbar from 'components/Navbars/AdminNavbar.js';
import Sidebar from 'components/Sidebar';
import React, { useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import routes from 'routes.js';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
// Custom Chakra theme
import theme from 'theme/theme.js';
import FixedPlugin from '../components/FixedPlugin/FixedPlugin';
// Custom components
import MainPanel from '../components/Layout/MainPanel';
import PanelContainer from '../components/Layout/PanelContainer';
import PanelContent from '../components/Layout/PanelContent';


export default function Dashboard(props) {
	const { ...rest } = props;
	// states and functions
	const [ sidebarVariant, setSidebarVariant ] = useState('transparent');
	const [ fixed, setFixed ] = useState(false);
	const [ data, setData ] = React.useState([]);

	const [ loading, setLoading ] =  React.useState(true);
	const [ error, setError ] =  React.useState(null);
	// functions for changing the states from components


	// load in data.json from public folder
	React.useEffect(() => {
	    fetchData();
	},[])

    // fetch data in fetchData function
    const fetchData = async () => {
        setData([]);
        fetch('/cam/tools/request/getData.php?view=year_record&startkey=1000&endkey=2020') // /data.json') //
                    .then((res) => res.json())
                    .then((data) => {
                    const fullData = [];
                    data.rows.forEach((item) => {
                    fullData.push({
                        id: item.id,
                        key: item.key,
                        core: item.value.core,
                        author: item.value.author,
                        country: item.value.country,
                        language: item.value.language,
                        short_title: item.value.short_title,
                        title: item.value.title,
                        year: item.value.year,
                    });

                    });

                        setData(fullData);
//                        setAuthorData(uniqueAuthors);
        //                setLoading(false);
                    })
                    .catch((error) => {
            console.debug({ error })
                        setError(error);
        //                setLoading(false);
                    });
    }

	const getRoute = () => {
		return window.location.pathname !== '/admin/full-screen-maps';
	};
	const getActiveRoute = (routes) => {
		let activeRoute = 'Default Brand Text';
		for (let i = 0; i < routes.length; i++) {
			if (routes[i].collapse) {
				let collapseActiveRoute = getActiveRoute(routes[i].views);
				if (collapseActiveRoute !== activeRoute) {
					return collapseActiveRoute;
				}
			} else if (routes[i].category) {
				let categoryActiveRoute = getActiveRoute(routes[i].views);
				if (categoryActiveRoute !== activeRoute) {
					return categoryActiveRoute;
				}
			} else {
				if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
					return routes[i].name;
				}
			}
		}
		return activeRoute;
	};
	// This changes navbar state(fixed or not)
	const getActiveNavbar = (routes) => {
		let activeNavbar = false;
		for (let i = 0; i < routes.length; i++) {
			if (routes[i].category) {
				let categoryActiveNavbar = getActiveNavbar(routes[i].views);
				if (categoryActiveNavbar !== activeNavbar) {
					return categoryActiveNavbar;
				}
			} else {
				if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
					if (routes[i].secondaryNavbar) {
						return routes[i].secondaryNavbar;
					}
				}
			}
		}
		return activeNavbar;
	};
	const getRoutes = (routes) => {
		return routes.map((prop, key) => {
			if (prop.collapse) {
				return getRoutes(prop.views);
			}
			if (prop.category === 'account') {
				return getRoutes(prop.views);
			}
			if (prop.layout === '/admin') {
				return <Route path={prop.layout + prop.path}
				 component={() => <prop.component fetchData={fetchData} data={data} />}
				 key={key} />;
			} else {
				return null;
			}
		});
	};
	const { isOpen, onOpen, onClose } = useDisclosure();
	document.documentElement.dir = 'ltr';

	console.debug({theme})
	theme.colors.yellow['700'] = "#b67a6a"
	// Chakra Color Mode
	return (
		<ChakraProvider theme={theme} resetCss={false}>
			<Sidebar
				routes={routes}
				logoText={'Copyright History Admin'}
				display='none'
				sidebarVariant={sidebarVariant}
				{...rest}
			/>
			<MainPanel
				w={{
					base: 'calc(100% - 232px)',
					xl: 'calc(100% - 232px)'
				}}><>
				<iframe id="previewFrameee" src={"https://www.copyrighthistory.org/cam/tools/manager/editor-admin.php"} style={{ display: 'none' }}></iframe>
				{data.length === 0 && <div style={{
                                               position: 'fixed',
                                               height: '100%',
                                               minWidth: '728px',
                                               scroll: 'auto',
                                               top: '25%',
                                               bottom: 0,
                                               left: '45%',
                                               right: 0,
                                               fontWeight: 800,
                                           }}>Fetching documents...</div> }
				{data.length > 0 && getRoute() ? (
					<PanelContent>
						<PanelContainer>
							<Switch>
								{getRoutes(routes)}
								<Redirect from='/admin' to='/admin/dashboard' />
							</Switch>
						</PanelContainer>
					</PanelContent>
				) : null}
				<Footer />
				<Portal>
					<FixedPlugin secondary={getActiveNavbar(routes)} fixed={fixed} onOpen={onOpen} />
				</Portal>
				</>
			</MainPanel>
		</ChakraProvider>
	);
}
